// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file team_service.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptyMessageResponseSchema, IdRequestSchema } from "./general_pb";
import { file_general } from "./general_pb";
import type { TeamCreateSchema, TeamListRequestSchema, TeamListSchema, TeamSchema, TeamUpdateSchema } from "./team_pb";
import { file_team } from "./team_pb";

/**
 * Describes the file team_service.proto.
 */
export const file_team_service: GenFile = /*@__PURE__*/
  fileDesc("ChJ0ZWFtX3NlcnZpY2UucHJvdG8SCXJhY2Nvb25haTKuAgoLVGVhbVNlcnZpY2USNAoKQ3JlYXRlVGVhbRIVLnJhY2Nvb25haS5UZWFtQ3JlYXRlGg8ucmFjY29vbmFpLlRlYW0SMAoHR2V0VGVhbRIULnJhY2Nvb25haS5JZFJlcXVlc3QaDy5yYWNjb29uYWkuVGVhbRI0CgpVcGRhdGVUZWFtEhUucmFjY29vbmFpLlRlYW1VcGRhdGUaDy5yYWNjb29uYWkuVGVhbRI8CglMaXN0VGVhbXMSGi5yYWNjb29uYWkuVGVhbUxpc3RSZXF1ZXN0GhMucmFjY29vbmFpLlRlYW1MaXN0EkMKCkRlbGV0ZVRlYW0SFC5yYWNjb29uYWkuSWRSZXF1ZXN0Gh8ucmFjY29vbmFpLkVtcHR5TWVzc2FnZVJlc3BvbnNlQgZaBC4vcGI", [file_general, file_team]);

/**
 * @generated from service raccoonai.TeamService
 */
export const TeamService: GenService<{
  /**
   * @generated from rpc raccoonai.TeamService.CreateTeam
   */
  createTeam: {
    methodKind: "unary";
    input: typeof TeamCreateSchema;
    output: typeof TeamSchema;
  },
  /**
   * @generated from rpc raccoonai.TeamService.GetTeam
   */
  getTeam: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof TeamSchema;
  },
  /**
   * @generated from rpc raccoonai.TeamService.UpdateTeam
   */
  updateTeam: {
    methodKind: "unary";
    input: typeof TeamUpdateSchema;
    output: typeof TeamSchema;
  },
  /**
   * @generated from rpc raccoonai.TeamService.ListTeams
   */
  listTeams: {
    methodKind: "unary";
    input: typeof TeamListRequestSchema;
    output: typeof TeamListSchema;
  },
  /**
   * @generated from rpc raccoonai.TeamService.DeleteTeam
   */
  deleteTeam: {
    methodKind: "unary";
    input: typeof IdRequestSchema;
    output: typeof EmptyMessageResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_team_service, 0);

